import React from 'react';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import Profile from './components/sections/Profile';
import Skills from './components/sections/Skills';
import Works from './components/sections/Works';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import './styles/globals.css';
import './styles/animations.css';

function App() {
    return (
        <div className="App">
            <Header />
            <main>
                <Hero />
                <Profile />
                <Skills />
                <Works />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;